import { styled } from '$utils/theme'
import { Button } from '$views/components'
import * as React from 'react'
import { css } from 'styled-components'

interface Props {
  active?: boolean
  withIcon?: boolean
  dark?: boolean
  onClick: () => void
}

const StyledButton = styled(Button).attrs({})<Props>`
  ${p =>
    p.dark &&
    css`
      background-color: ${p.theme.colors.darkGrey};
      color: ${p.theme.colors.white};
      border-color: ${p.theme.colors.white};
    `}
  border-width: 1px;
`

export const TabButton: React.FC<Props> = props => {
  const { active, dark, withIcon, onClick, children, ...restProps } = props

  return (
    <StyledButton
      mini
      bordered
      {...restProps}
      primary={active && !dark}
      dark={active && dark}
      tertiary={!active}
      withIcon={withIcon}
      onClick={onClick}
    >
      {children}
    </StyledButton>
  )
}



// WEBPACK FOOTER //
// ./src/views/components/TabButton.tsx